'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var culture = {
  'model': {

    'natureType': {
      'title': 'Sottomenù',
      'type': 'select',
      'enum': ['FLORA', 'FAUNA', 'HABITAT', 'GEOLOGIA'],
      'prefix': 'vm.item.nature',
      'required': true
    },

    'title': {
      'title': 'Titolo',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'municipality': {
      'title': 'Comune',
      'type': 'input',
      'prefix': 'vm.item.nature',
      'required': false
    },

    'category': {
      'title': 'Categoria',
      'type': 'input',
      'prefix': 'vm.item.nature',
      'required': false
    },

    'phoneNumber': {
      'title': 'Numero di telefono',
      'type': 'input',
      'prefix': 'vm.item.nature'
    },

    'eMail': {
      'title': 'E-mail',
      'type': 'input',
      'prefix': 'vm.item.nature'
    },

    'webSite': {
      'title': 'Sito web',
      'type': 'input',
      'prefix': 'vm.item.nature'
    },

    'description': {
      'title': 'Descrizione',
      'type': 'editor',
      'prefix': 'lang',
      'row': 8
    },

    'location': {
      'title': 'Ubicazione',
      'type': 'input',
      'prefix': 'lang',
      'required': true
    },

    'timetable': {
      'title': 'Orari e stagionalità',
      'type': 'input',
      'prefix': 'lang'
    },

    'note': {
      'title': 'Note',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    },

    'additionalInformations': {
      'title': 'Approfondisci',
      'type': 'editor',
      'prefix': 'lang',
      'row': 2
    }
  }
};

exports.default = culture;


// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/nature.model.js